import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PointInterest } from '../models';
import * as L from 'leaflet';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import { Observable } from 'rxjs';
import { MapService } from './map.service';

@Injectable({
  providedIn: 'root'
})
export class PointInterestService {
  pointInterests: PointInterest[] = null;

  pointOfInterestUrl = environment.dns + 'api/pointInterests/';

  constructor(private _http: HttpClient, private map: MapService) { }

  getAllPointInterests(): Observable<PointInterest[]> {
    return this._http
      .get<PointInterest[]>(this.pointOfInterestUrl);
  }

  addPointInterest(pointInterest: PointInterest): Observable<PointInterest> {
    return this._http
      .post<PointInterest>(this.pointOfInterestUrl, pointInterest);
  }

  deletePointInterest(id: number): Observable<Boolean> {
    return this._http
      .delete<Boolean>(this.pointOfInterestUrl + id);
  }

  updatePointInterest(pointinterest: PointInterest): Observable<PointInterest> {
    let body = JSON.stringify(pointinterest);
    return this._http
      .put<PointInterest>(this.pointOfInterestUrl, pointinterest);
  }

  getOne(id: number): Observable<PointInterest> {
    return this._http.get<PointInterest>(this.pointOfInterestUrl + id);
}

  getPointInterestById(id: number) {
    return this.pointInterests.filter(
      pointInterest => pointInterest.idPointInterest === id
    );
  }

  getPolygons(): PointInterest[] {
    return this.pointInterests.filter(
      pointInterest => pointInterest.type === 'POLYGON'
    );
  }

  getMarkers(): PointInterest[] {
    return this.pointInterests.filter(
      pointInterest => pointInterest.type === 'MARKER'
    );
  }

}
